module.exports = __webpack_public_path__ + "img/icon-button-selected.1352e62f.png";